<template>
  <div class="mathRoad_container">
    <div
      :class="{
        container_bg: true,
        container_green: curBG === 'typeGreen' ? true : false,
      }"
      :style="{ visibility: roadMapType == '2d' ? 'visible' : 'hidden' }"
    >
      <img :src="getContainerBG" v-if="backgroundMask" />
    </div>
    <div class="overal_bg" v-if="curBG == 'typeDark'" v-show="roadMapType == '2d'"></div>
    <div class="map2DBG" v-if="isShowType2D" v-show="roadMapType == '2d'">
      <div class="mapSide"></div>
    </div>
    <div class="map2D">
      <ColorScreenMod
        :roadMapType="roadMapType"
        @change3dMap="change3dMap"
        @closeVehicleDetail="closeVehicleDetail"
        :carNum="carNum"
        :selCamera="selCamera"
      ></ColorScreenMod>
    </div>
    <!--carScreen></carScreen-->

    <left-part
      :modelType="modelType"
      v-if="!isSetting && refreshTag && roadMapType == '2d'"
    ></left-part>
    <right-part
      :modelType="modelType"
      v-if="!isSetting && refreshTag && roadMapType == '2d'"
    ></right-part>
    <setting
      style="z-index: 2"
      :modelType="modelType"
      v-if="isSetting && roadMapType == '2d'"
    ></setting>
    <cameraRound v-if="false" />
    <streetTooltips v-if="false" />
    <weatherBox v-if="isNewEdition && false" />
    <centerModeDarkUnityRoad
      @openCamera="openCamera"
      @clickCarNum="clickCarNum"
      @closeCarNum="closeCarNum"
      @switch2dMap="switch2dMap"
      :closeVehicleTag="closeVehicleTag"
      v-show="roadMapType == '3d'"
      class="pathMathRoad"
    />
    <videoBox ref="roadVideoBox" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import leftPart from "@/modules/DIYcomponents/leftPart.vue";
import rightPart from "@/modules/DIYcomponents/rightPart.vue";
import setting from "@/modules/DIYcomponents/setting.vue";
import centerModeDarkUnityRoad from "@/modules/centerMod/titleMenu/indexDarkUnityRoad.vue";
import carScreen from "@/views/ColorScreenMod/carScreen";

import ColorScreenMod from "@/views/ColorScreenMod/NewColorScreen.vue";

import { mapState, mapGetters } from "vuex";

import { ref, shallowRef, computed, provide } from "vue";

import {
  CamLeapFunc,
  Instantiate3DUIFunc,
  CloseFixedBrowserFunc,
  OpenFixedBrowserFunc,
} from "@/assets/js/unity3D/index.js";
import weatherBox from "@/modules/mathRoadComponents/weatherBox/weatherBox.vue";
import cameraRound from "@/modules/mathRoadComponents/roundCamera/roundCamera.vue";
import streetTooltips from "@/modules/mathRoadComponents/streetTooltips/streetTooltips.vue";
import { UIjson } from "@/modules/mathRoadComponents/outerWall/outerWallList.js";
import videoBox from "@/modules/videoComponents/videoBox.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    leftPart,
    rightPart,
    setting,
    centerModeDarkUnityRoad,
    cameraRound,
    streetTooltips,
    weatherBox,
    ColorScreenMod,
    carScreen,
    videoBox,
  },
  props: {},
  data() {
    //这里存放数据
    return {
      pageInfo: 'MathRoadMod.vue',
      computedName: '数字化道路组件',
      backgroundMask: bmeConfig.backgroundMask,
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,
      isSetting: false,
      hash: false,
      modelType: "MathRoadMod",
      styleType: bmeConfig.styleType,
      styleTypeMap: styleTypeMap,
      curBG: "",
      refreshTag: true,
      eventData: {},
      curMapType: "",

      isNewEdition: bmeConfig.isNewMathRoad,
      isShowRoadStatus: false,
      isShowType2D: true,
      isShowCarInfo: null,

      boxInfo: "",
      nvrInfo: "",
      roadMapType: "3d",

      carNum: "",
      selCamera: "",

      closeVehicleTag: "",
    };
  },
  computed: {
    getContainerBG: function () {
      let imgSrc = "";
      if (
        this.curBG &&
        this.styleTypeMap[this.curBG] &&
        this.styleTypeMap[this.curBG].dutyBG
      ) {
        imgSrc = require("@/views/MainMod/img/" + this.styleTypeMap[this.curBG].dutyBG);
      }
      if (!bmeConfig.backgroundMask) {
        imgSrc = "";
      }
      return imgSrc;
    },
    curBGVal: function () {
      return this.$store.state.curBG;
    },
    mapTypeVal() {
      return this.$store.state.mapType;
    },
  },
  errorCaptured(error,vm,info) {
    console.log('kk-',error,vm,info);
    let msg = '错误信息：' + error + '，错误详情：' + info;
    let computedName = vm.mtitle || vm.computedName;
    return false;
    // this.requestExceptCap(msg,instance);
  },
  provide: function () {
    return {
      getEventData: computed(() => this.eventData),
      updateEventData: this.updateEventData,

      getRoadStatus: computed(() => this.isShowRoadStatus),
      updateRoadStatus: this.updateRoadStatus,
      changeIsShowCarInfo: this.changeIsShowCarInfo,
      changeIsShowType2D: this.changeIsShowType2D,

      getRoadBoxInfo: computed(() => this.boxInfo),
      getRoadNvrInfo: computed(() => this.nvrInfo),
      updateRoadNvrInfoBox: this.updateNvrInfoBox,
    };
  },
  //监控data中的数据变化
  watch: {
    "$store.state.roadVideoBoxSwitch": {
      handler(val, oldVal) {
        if (val === "open") {
          $(this.$refs.roadVideoBox.$el).fadeIn(0, () => {
            $(this.$refs.roadVideoBox.$el).css("display", "inital");
          });
        } else {
          this.$refs.roadVideoBox.closeBtn();
          $(this.$refs.roadVideoBox.$el).fadeOut(0);
        }
      },
      deep: true, //true 深度监听
    },
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal;
      },
      deep: true,
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal;
      },
      deep: true,
    },
    mapTypeVal: {
      handler(newVal, oldVal) {
        this.curMapType = newVal;
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    closeVehicleDetail() {
      this.closeVehicleTag = new Date().getTime();
    },
    openCamera(data) {
      console.log(data);
      this.selCamera = data;
    },
    clickCarNum(carNum) {
      this.carNum = carNum;
    },
    closeCarNum() {
      this.carNum = "";
    },
    switch2dMap() {
      this.roadMapType = "2d";
    },
    change3dMap() {
      this.roadMapType = "3d";
    },
    updateNvrInfoBox(val, obj = 0) {
      this.nvrInfo = val;
      this.boxInfo = obj;
    },
    // 是否展示小车
    changeIsShowCarInfo(status) {
      this.isShowCarInfo = status;
    },
    // 展示2D还是3D地图
    changeIsShowType2D(status) {
      this.isShowType2D = status;
    },
    flyTo() {
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        const earth = window.g_bme3dManager.earth;
        let view =
          mapViews[`mapViews_${this.customerId}`] &&
          mapViews[`mapViews_${this.customerId}`].dutyMod;
        if (view && view.length) {
          earth.camera.flyTo(view[0], view[1], view[2], view[3]);
        } else {
          g_bme3dManager.flyAround();
        }
      }
    },
    isBme3dManagerLoaded() {
      if (bmeConfig.mapType !== "3D") return;
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        this.bme3dManagerLoaded = true;
        this.flyTo();
      } else {
        let that = this;
        if (that.loadedTimer) {
          clearTimeout(that.loadedTimer);
        }
        that.loadedTimer = setTimeout(function () {
          that.isBme3dManagerLoaded();
        }, 100);
      }
    },
    updateEventData(item) {
      this.eventData = item;
    },
    updateRoadStatus(item) {
      this.isShowRoadStatus = item;
    },
    reset() {
      this.modelType = "MathRoadMod";
      this.refreshTag = true;
      this.eventData = {};
    },
    reload() {
      let that = this;
      this.refreshTag = false;
      this.$nextTick(function () {
        that.reset();
        this.refreshTag = true;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query && this.$route.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.curMapType = this.$store.state.mapType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.curBG = this.$store.state.curBG;
    if (this.isNewEdition) {
      // Instantiate3DUIFunc(UIjson);
    }
    this.switch2dMap();
  },
  unmounted() {
    if (this.isNewEdition) {
      UIjson?.data?.forEach((item) => {
        CloseFixedBrowserFunc(item.id);
      });
    }
  },
  activated() {},
  deactivated() {},
  beforeUnmount() {},
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.reload();
  },
  beforeRouteEnter(to, from) {
    CamLeapFunc();
  },
};
</script>
<style scoped lang="scss">
.map2DBG {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: url("./img/cao.png") no-repeat;
  background-size: cover;
  z-index: -2;
  /* background-color: rgb(119,158,87); */
  .mapSide {
    width: 100%;
    height: 100%;
    background: url("./img/side.png") no-repeat;
    background-size: cover;
  }
}
.map2D {
  /*position: absolute;
  width: 1080px;
  height: 1920px;
  transform: scale(0.8) rotate(90deg);
  transform-origin: top left;
  left: 2800px;
  top: 158px;*/
  position: absolute;
  width: 1080px;
  height: 1920px;
  transform: scale(1) rotate(90deg);
  transform-origin: top left;
  left: 2950px;
  top: 55px;
}
.mathRoad_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}

.changeSet {
  display: block;
  height: 100px;
  width: 100px;
  background: black;
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: all;
}

.pathMathRoad {
  position: absolute;
  bottom: 116px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: all;
}
</style>
